import { CompanyDetails } from '@/types/companies';
import { Card, Typography, Box } from '@mui/material';
import { SVLink } from '@/components/core';
import { ROUTES } from '@/constants/routes';

type CompanyBrandingThemesProps = {
  companyDetails: CompanyDetails;
};

export default function CompanyBrandingThemes({
  companyDetails,
}: CompanyBrandingThemesProps) {
  const { brandingTheme } = companyDetails;

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>
        Branding Theme
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <Typography>
          {brandingTheme.name} ({brandingTheme.level})
        </Typography>
        <SVLink
          to={`${ROUTES.BRANDING_THEME_VIEW_PARAMS}/${brandingTheme.uuid}`}>
          View Branding Theme
        </SVLink>
      </Box>
    </Card>
  );
}
